import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { Box, Typography, Grid } from '@material-ui/core';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { BUTTON_TYPES } from '../../common/constant.js';

var useStyles = makeStyles(function (theme) {
  return {
    mb24text: {
      marginBottom: theme.spacing(3),
      color: theme.palette.text.white
    },
    cta: _defineProperty({
      padding: theme.spacing(1, 2),
      minWidth: theme.spacing(31.5)
    }, theme.breakpoints.up("lg"), {
      maxWidth: theme.spacing(40),
      marginRight: theme.spacing(2)
    })
  };
});
var Banner = function Banner(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleStyle = _ref.titleStyle,
    subtitleStyle = _ref.subtitleStyle,
    bgColor = _ref.bgColor,
    ctas = _ref.ctas;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isSmallScreen = _useBreakpoints.isSmallScreen,
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isMediumScreen = _useBreakpoints.isMediumScreen;
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    px: isExtraSmallScreen() || isSmallScreen() ? 2 : 28.25,
    py: 7.5
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle && titleStyle.headingVariant ? titleStyle.headingVariant : "h3",
    align: titleStyle && titleStyle.textAlignment ? titleStyle.textAlignment.toLowerCase() : "center",
    className: classes.mb24text
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    variant: subtitleStyle && subtitleStyle.headingVariant ? subtitleStyle.headingVariant : "caption",
    align: subtitleStyle && subtitleStyle.textAlignment ? subtitleStyle.textAlignment.toLowerCase() : "center",
    className: classes.mb24text
  }, subtitle), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: isExtraSmallScreen() || isSmallScreen() || isMediumScreen() ? "column" : "row",
    justify: isSmallScreen() || isExtraSmallScreen() ? "center" : "flex-start"
  }, ctas && ctas.map(function (cta) {
    var _BUTTON_TYPES$cta$typ, _BUTTON_TYPES$cta$typ2;
    return /*#__PURE__*/React__default.createElement(Grid, {
      key: cta === null || cta === void 0 ? void 0 : cta.title,
      item: true
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      className: classes.cta,
      variant: (_BUTTON_TYPES$cta$typ = BUTTON_TYPES[cta.type]) === null || _BUTTON_TYPES$cta$typ === void 0 ? void 0 : _BUTTON_TYPES$cta$typ.variant,
      color: (_BUTTON_TYPES$cta$typ2 = BUTTON_TYPES[cta.type]) === null || _BUTTON_TYPES$cta$typ2 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ2.color,
      href: cta.url,
      size: "large",
      fullWidth: true
    }, cta === null || cta === void 0 ? void 0 : cta.title));
  }))));
};
Banner.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  titleStyle: PropTypes__default.shape({
    target: PropTypes__default.string,
    textAlignment: PropTypes__default.string,
    headingVariant: PropTypes__default.string,
    headingStyle: PropTypes__default.string
  }),
  subtitleStyle: PropTypes__default.shape({
    target: PropTypes__default.string,
    textAlignment: PropTypes__default.string,
    headingVariant: PropTypes__default.string,
    headingStyle: PropTypes__default.string
  }),
  bgColor: PropTypes__default.string,
  ctas: PropTypes__default.array
};

export { Banner as default };
//# sourceMappingURL=Banner.js.map
